const initialState = {
  fetchDisciplinePending: false,
  fetchDisciplineError: null,
  discipline: [],
  fetchBannerListPending: false,
  fetchBannerListError: null,
  bannerList: [],
  fetchCourseLookInfoPending: false,
  fetchCourseLookInfoError: null,
  courseLookInfo: {},
  fetchMessageDataPending: false,
  fetchMessageDataError: null,
  messageData: [],
  fetchHomeModelListPending: false,
  fetchHomeModelListError: null,
  homeModelList: {},
  fetchMenuListPending: false,
  fetchMenuListError: null,
  menuList: [],
  fetchGetStuInfoBySIdPending: false,
  fetchGetStuInfoBySIdError: null,
  fetchCreatePromoterPending: false,
  fetchCreatePromoterError: null,
  fetchStudentPublicListPending: false,
  fetchStudentPublicListError: null,
  fetchGetExperienceClassPending: false,
  fetchGetExperienceClassError: null,
  fetchGetExperienceClassSuccess: null,
  fetchGetExperienceClassTotal: 0,
  fetchGetHomeHotRecommendPending: false,
  fetchGetHomeHotRecommendError: null,
  adImageData: null,
  isShowAdImage: null,
  vipData: null,
  isShowVip: null,
  recommendData: null,
  isShowRecommend: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js